module.exports = __webpack_public_path__ + "static/media/Miami soffa 2-sits tyg siri grön 06 detalj 2023 10.f16c92f4.jpg";